import type { AssetsLiabilities } from "@/types/types";
import Asset from "./Asset";

type Props = {
  liabilities: AssetsLiabilities[] | undefined;
  totalLiabilities: number;
};

export default function Liabilities({ liabilities, totalLiabilities }: Props) {
  return (
    <div className="w-full rounded-md bg-neutral-500 p-8 sm:w-1/2">
      <span className="text-lg font-medium text-neutral-100">Debts & Liabilities</span>
      <div className="mt-4">
        <Asset additionalAssets={liabilities ?? []} assetsTotal={totalLiabilities} />
      </div>
    </div>
  );
}
